<div class="settings settings-content">
  <div *ngIf="employee?.isEmployeeOwner">
    <content-title-v2 [title]="'Settings.Company.company' | translate" />

    <div class="settings-content-section-forms">
      <company-base-data [form]="form" />
      <hr class="spacer-v2" />
      <company-extend-data [form]="form" />
      <hr class="spacer-v2 mt-0" />
      <company-payments [form]="form" />
      <hr class="spacer-v2" />
    </div>
  </div>
  <company-no-account *ngIf="userPerson.canCreateCompany" />
</div>
